import React from 'react';
import { Link } from 'react-router-dom';
import { ChatBubbleLeftRightIcon, UserPlusIcon, DocumentPlusIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

/**
 * ActivityFeed component displays recent activities in the RAG chatbot system
 * including conversations, user registrations, and knowledge base updates.
 */
const ActivityFeed = ({ data = [] }) => {
  // Function to get the appropriate icon based on activity type
  const getActivityIcon = (type) => {
    switch (type) {
      case 'conversation':
        return <ChatBubbleLeftRightIcon className="h-5 w-5 text-blue-500" />;
      case 'user':
        return <UserPlusIcon className="h-5 w-5 text-green-500" />;
      case 'knowledge':
        return <DocumentPlusIcon className="h-5 w-5 text-purple-500" />;
      case 'alert':
        return <ExclamationTriangleIcon className="h-5 w-5 text-red-500" />;
      default:
        return <ChatBubbleLeftRightIcon className="h-5 w-5 text-gray-500" />;
    }
  };

  return (
    <div className="sm-card p-6 h-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-white">Activity Feed</h2>
        <Link to="/conversations" className="text-sm text-blue-400 hover:text-blue-300">
          View All
        </Link>
      </div>
      
      {data.length > 0 ? (
        <div className="space-y-4">
          {data.map((activity) => {
            const body = (
              <>
                <div className="p-2 rounded-full bg-gray-700 mr-3">
                  {getActivityIcon(activity.type)}
                </div>
                <div>
                  <p className="text-sm font-medium text-white">{activity.title}</p>
                  <p className="text-xs text-gray-400">{activity.timestamp}</p>
                </div>
              </>
            );
            const key = `${activity.type}-${activity.id}`;
            return activity.link ? (
              <Link
                key={key}
                to={activity.link}
                className="flex items-start border-b border-gray-700 pb-4 rounded-md hover:bg-gray-700/30 transition-colors -mx-2 px-2"
              >
                {body}
              </Link>
            ) : (
              <div key={key} className="flex items-start border-b border-gray-700 pb-4">
                {body}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-400">
          <p>No recent activity</p>
        </div>
      )}
    </div>
  );
};

export default ActivityFeed;
